var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M82.62,7.4h-38.45C19.81,7.4,0,27.21,0,51.57s19.81,44.17,44.17,44.17h10.47v17.49c0,.23,0,.46.01.67,0,.1,0,.21,0,.32,0,.19,0,.39,0,.6,0,.43-.02.87.05,1.35.09.6.25,1.37.74,2.05.63.89,1.64,1.38,2.85,1.38.01,0,.02,0,.03,0,.67,0,1.34-.12,1.92-.33.55-.2,1.04-.51,1.43-.9l22.66-22.67h.05c23.76-.96,42.38-20.34,42.38-44.13S106.97,7.4,82.62,7.4ZM82.62,87.47c-1.09,0-2.16.44-2.92,1.21l-16.65,16.65.04-13.73c0-2.28-1.85-4.13-4.13-4.13h-14.78c-19.8,0-35.9-16.11-35.9-35.9S24.37,15.67,44.17,15.67h38.45c19.8,0,35.9,16.11,35.9,35.9s-16.11,35.9-35.9,35.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsOutline);
export default __webpack_public_path__ + "static/media/contact-us-outline.4fff8d9aa1be9c7c0a92ed8b707c97fa.svg";
export { ForwardRef as ReactComponent };